import React, { useState, useEffect, useRef } from 'react';
import { API, authFetch } from '../utils/api';

// 경매 통계 — 실시간 현황 + 기간별 종합 + 차종별 + 최근낙찰 + 내 성적표
function AuctionStats(props){
  var onViewAuction=props.onViewAuction;
  var onGotoMarketplace=props.onGotoMarketplace;

  var[overview,setOverview]=useState(null);
  var[myStats,setMyStats]=useState(null);
  var[days,setDays]=useState(30);
  var[loading,setLoading]=useState(true);
  var[error,setError]=useState('');
  var[showMyStats,setShowMyStats]=useState(false);

  var rtTimerRef=useRef(null);

  var fmt=function(n){return Number(n||0).toLocaleString()};
  var fmtMan=function(won){return Math.round((won||0)/10000).toLocaleString()};

  var loadOverview=function(d,realtimeOnly){
    if(!realtimeOnly)setLoading(true);
    setError('');
    authFetch(API+'/auctions/stats/overview?days='+d)
      .then(function(r){return r.json()})
      .then(function(resp){
        if(resp&&resp.success&&resp.data){
          if(realtimeOnly){
            setOverview(function(prev){return prev?Object.assign({},prev,{realtime:resp.data.realtime}):resp.data});
          }else{
            setOverview(resp.data);
          }
        }else{
          setError((resp&&resp.error)||'통계를 불러오지 못했습니다. 다시 시도해주세요.');
        }
      })
      .catch(function(){setError('통계를 불러오지 못했습니다. 다시 시도해주세요.')})
      .then(function(){if(!realtimeOnly)setLoading(false)});
  };

  var loadMy=function(){
    authFetch(API+'/auctions/stats/my')
      .then(function(r){return r.json()})
      .then(function(resp){if(resp&&resp.success&&resp.data)setMyStats(resp.data)})
      .catch(function(){});
  };

  useEffect(function(){
    loadOverview(days,false);
    loadMy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[days]);

  // 30초마다 실시간 현황 바만 갱신
  useEffect(function(){
    rtTimerRef.current=setInterval(function(){loadOverview(days,true)},30000);
    return function(){if(rtTimerRef.current)clearInterval(rtTimerRef.current)};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[days]);

  var relTime=function(ts){
    if(!ts)return '';
    var t=new Date(String(ts).replace(' ','T')).getTime();
    var diff=Math.floor((Date.now()-t)/1000);
    if(diff<60)return '방금 전';
    if(diff<3600)return Math.floor(diff/60)+'분 전';
    if(diff<86400)return Math.floor(diff/3600)+'시간 전';
    return Math.floor(diff/86400)+'일 전';
  };

  var rateColor=function(r){
    if(r>=70)return '#10b981';
    if(r>=50)return '#f59e0b';
    return '#ef4444';
  };

  // 스켈레톤
  if(loading&&!overview){
    return (
      <div style={{padding:'20px 24px',maxWidth:1200,margin:'0 auto'}}>
        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
          {[0,1,2,3].map(function(i){return <div key={i} style={{height:80,background:'linear-gradient(90deg,#f1f5f9,#e2e8f0,#f1f5f9)',borderRadius:12}}/>})}
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12}}>
          {[0,1,2,3,4,5].map(function(i){return <div key={i} style={{height:96,background:'linear-gradient(90deg,#f1f5f9,#e2e8f0,#f1f5f9)',borderRadius:12}}/>})}
        </div>
      </div>
    );
  }

  if(error&&!overview){
    return (
      <div style={{padding:'20px 24px',maxWidth:1200,margin:'0 auto'}}>
        <div style={{padding:'40px 20px',textAlign:'center',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:12,color:'#dc2626',fontSize:14}}>
          ⚠ {error}
          <div style={{marginTop:14}}>
            <button onClick={function(){loadOverview(days,false)}}
              style={{padding:'10px 22px',background:'#dc2626',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:700,cursor:'pointer'}}>
              다시 시도
            </button>
          </div>
        </div>
      </div>
    );
  }

  var rt=(overview&&overview.realtime)||{};
  var p=(overview&&overview.period)||{};
  var makers=(overview&&overview.byMaker)||[];
  var recent=(overview&&overview.recentSold)||[];
  var maxMakerTotal=makers.reduce(function(m,x){return x.total>m?x.total:m},1);

  var rtCards=[
    {label:'진행중 경매',value:rt.activeCount||0,suffix:'건',bg:'#fef2f2',bd:'#fecaca',color:'#dc2626',icon:'🔴',filter:'active'},
    {label:'선택 대기',value:rt.pendingSelectionCount||0,suffix:'건',bg:'#fffbeb',bd:'#fde68a',color:'#b45309',icon:'🟡',filter:'pending_selection'},
    {label:'오늘 입찰',value:rt.totalBidsToday||0,suffix:'건',bg:'#eff6ff',bd:'#bfdbfe',color:'#1d4ed8',icon:'📊',filter:null},
    {label:'오늘 조회',value:rt.totalViewsToday||0,suffix:'회',bg:'#f8fafc',bd:'#e2e8f0',color:'#475569',icon:'👀',filter:null}
  ];

  var periodCards=[
    {icon:'📦',label:'총 출품',value:fmt(p.totalListings),suffix:'건'},
    {icon:'✅',label:'낙찰 성사',value:fmt(p.soldCount),suffix:'건'},
    {icon:'📈',label:'낙찰률',value:p.totalListings>0?p.successRate:'-',suffix:'%',color:p.totalListings>0?rateColor(p.successRate):null},
    {icon:'💰',label:'평균 낙찰가',value:p.soldCount>0?fmtMan(p.avgWinningBid):'-',suffix:'만원'},
    {icon:'🏆',label:'최고 낙찰가',value:p.soldCount>0?fmtMan(p.maxWinningBid):'-',suffix:'만원'},
    {icon:'📉',label:'최저 낙찰가',value:p.soldCount>0?fmtMan(p.minWinningBid):'-',suffix:'만원'},
    {icon:'🔢',label:'경매당 평균 입찰',value:p.totalListings>0?p.avgBidsPerAuction:'-',suffix:'건'},
    {icon:'📊',label:'평균 프리미엄',value:p.soldCount>0?fmtMan(p.avgPriceGap):'-',suffix:'만원'},
    {icon:'💎',label:'총 거래금액',value:p.soldCount>0?fmtMan(p.totalTransactionVolume):'-',suffix:'만원'}
  ];

  var sellerStats=(myStats&&myStats.asSeller)||{};
  var buyerStats=(myStats&&myStats.asBuyer)||{};

  return (
    <div style={{padding:'20px 24px',maxWidth:1200,margin:'0 auto',minHeight:'100%'}}>

      {/* 헤더 */}
      <div style={{marginBottom:18}}>
        <h1 style={{fontSize:22,fontWeight:800,color:'#1B3A5C',margin:0,display:'flex',alignItems:'center',gap:8}}>
          <span>📊</span><span>경매 통계</span>
        </h1>
        <div style={{fontSize:12,color:'#64748b',marginTop:4}}>실시간 현황 · 자동 갱신 30초</div>
      </div>

      {/* ① 실시간 현황 바 */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit, minmax(180px, 1fr))',gap:12,marginBottom:22}}>
        {rtCards.map(function(c,i){
          return (
            <div key={i} onClick={function(){if(c.filter&&onGotoMarketplace)onGotoMarketplace(c.filter)}}
              style={{padding:'14px 16px',background:c.bg,border:'1px solid '+c.bd,borderRadius:12,cursor:c.filter?'pointer':'default',transition:'transform 0.15s'}}
              onMouseEnter={function(e){if(c.filter)e.currentTarget.style.transform='translateY(-2px)'}}
              onMouseLeave={function(e){e.currentTarget.style.transform='none'}}>
              <div style={{fontSize:11,color:'#64748b',fontWeight:600,display:'flex',alignItems:'center',gap:4}}>
                <span>{c.icon}</span><span>{c.label}</span>
              </div>
              <div style={{fontSize:26,fontWeight:800,color:c.color,marginTop:4}}>
                {fmt(c.value)}<span style={{fontSize:13,fontWeight:700,marginLeft:4,color:'#64748b'}}>{c.suffix}</span>
              </div>
            </div>
          );
        })}
      </div>

      {/* ② 기간 선택 + 종합 통계 */}
      <div style={{marginBottom:18}}>
        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:12,flexWrap:'wrap'}}>
          <div style={{fontSize:13,fontWeight:700,color:'#475569',marginRight:4}}>📅 기간</div>
          {[{k:7,l:'7일'},{k:30,l:'30일'},{k:90,l:'90일'},{k:0,l:'전체'}].map(function(opt){
            var active=days===opt.k;
            return (
              <button key={opt.k} onClick={function(){setDays(opt.k)}}
                style={{padding:'6px 14px',borderRadius:9999,border:'1px solid '+(active?'#1B3A5C':'#cbd5e1'),background:active?'#1B3A5C':'#fff',color:active?'#fff':'#475569',fontSize:12,fontWeight:active?800:600,cursor:'pointer'}}>
                {opt.l}
              </button>
            );
          })}
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit, minmax(160px, 1fr))',gap:12}}>
          {periodCards.map(function(c,i){
            return (
              <div key={i} style={{padding:'14px 16px',background:'#fff',border:'1px solid #e2e8f0',borderRadius:12}}>
                <div style={{fontSize:12,color:'#64748b',fontWeight:600,display:'flex',alignItems:'center',gap:4}}>
                  <span>{c.icon}</span><span>{c.label}</span>
                </div>
                <div style={{fontSize:22,fontWeight:800,color:c.color||'#1e293b',marginTop:4,lineHeight:1.2}}>
                  {c.value}<span style={{fontSize:12,fontWeight:700,marginLeft:3,color:'#64748b'}}>{c.suffix}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* ③ 차종별 통계 */}
      <div style={{marginBottom:22,padding:'16px 18px',background:'#fff',border:'1px solid #e2e8f0',borderRadius:12}}>
        <div style={{fontSize:14,fontWeight:800,color:'#1e293b',marginBottom:14}}>🚗 차종별 통계 (상위 10)</div>
        {makers.length===0?(
          <div style={{padding:'30px 10px',textAlign:'center',color:'#94a3b8',fontSize:13}}>아직 통계 데이터가 없습니다</div>
        ):makers.map(function(m,i){
          var pct=Math.max(4,Math.round((m.total/maxMakerTotal)*100));
          return (
            <div key={i} style={{display:'flex',alignItems:'center',gap:10,marginBottom:10}}>
              <div style={{flex:'0 0 80px',fontSize:12,fontWeight:700,color:'#475569',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{m.maker}</div>
              <div style={{flex:1,height:20,background:'#f1f5f9',borderRadius:4,position:'relative',overflow:'hidden'}}>
                <div style={{position:'absolute',top:0,left:0,height:'100%',width:pct+'%',background:'#3B82F6',borderRadius:4,transition:'width 0.3s'}}/>
              </div>
              <div style={{flex:'0 0 auto',fontSize:11,color:'#64748b',minWidth:150,textAlign:'right'}}>
                출품 <strong style={{color:'#1e293b'}}>{m.total}</strong>건 · 낙찰 <strong style={{color:'#10b981'}}>{m.sold}</strong>건
                {m.sold>0&&<span> · 평균 <strong style={{color:'#1e293b'}}>{fmtMan(m.avgPrice)}</strong>만원</span>}
              </div>
            </div>
          );
        })}
      </div>

      {/* ④ 최근 낙찰 내역 */}
      <div style={{marginBottom:22,padding:'16px 18px',background:'#fff',border:'1px solid #e2e8f0',borderRadius:12}}>
        <div style={{fontSize:14,fontWeight:800,color:'#1e293b',marginBottom:12}}>🏁 최근 낙찰 내역</div>
        {recent.length===0?(
          <div style={{padding:'30px 10px',textAlign:'center',color:'#94a3b8',fontSize:13}}>-</div>
        ):recent.map(function(r){
          return (
            <div key={r.id} onClick={function(){if(onViewAuction)onViewAuction(r.id)}}
              style={{display:'flex',alignItems:'center',gap:12,padding:'10px 0',borderBottom:'1px solid #f1f5f9',cursor:'pointer'}}>
              <div style={{flex:1,fontSize:13,fontWeight:700,color:'#1e293b',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.title}</div>
              <div style={{flex:'0 0 auto',fontSize:13,fontWeight:800,color:'#10b981'}}>{fmtMan(r.winningBid)}만원</div>
              <div style={{flex:'0 0 60px',fontSize:11,color:'#64748b',textAlign:'right'}}>🔨 {r.bidCount}건</div>
              <div style={{flex:'0 0 70px',fontSize:11,color:'#94a3b8',textAlign:'right'}}>{relTime(r.soldAt)}</div>
            </div>
          );
        })}
      </div>

      {/* ⑤ 내 성적표 (접이식) */}
      <div style={{marginBottom:30,padding:'16px 18px',background:'#fff',border:'1px solid #e2e8f0',borderRadius:12}}>
        <button onClick={function(){setShowMyStats(!showMyStats)}}
          style={{width:'100%',background:'none',border:'none',display:'flex',alignItems:'center',justifyContent:'space-between',cursor:'pointer',padding:0}}>
          <div style={{fontSize:14,fontWeight:800,color:'#1e293b'}}>📋 내 거래 성적표</div>
          <div style={{fontSize:12,color:'#64748b'}}>{showMyStats?'▲ 접기':'▼ 펼치기'}</div>
        </button>
        {showMyStats&&(
          <div style={{marginTop:14,display:'grid',gridTemplateColumns:'repeat(auto-fit, minmax(260px, 1fr))',gap:14}}>
            <div style={{padding:'14px',background:'#f8fafc',borderRadius:10,border:'1px solid #e2e8f0'}}>
              <div style={{fontSize:12,fontWeight:700,color:'#1B3A5C',marginBottom:10}}>📤 출품자로서</div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,fontSize:12}}>
                <div style={{color:'#64748b'}}>출품</div><div style={{textAlign:'right',fontWeight:700}}>{fmt(sellerStats.listed)}건</div>
                <div style={{color:'#64748b'}}>낙찰</div><div style={{textAlign:'right',fontWeight:700,color:'#10b981'}}>{fmt(sellerStats.sold)}건</div>
                <div style={{color:'#64748b'}}>유찰</div><div style={{textAlign:'right',fontWeight:700}}>{fmt(sellerStats.failed)}건</div>
                <div style={{color:'#64748b'}}>취소</div><div style={{textAlign:'right',fontWeight:700}}>{fmt(sellerStats.cancelled)}건</div>
                <div style={{color:'#64748b'}}>낙찰률</div><div style={{textAlign:'right',fontWeight:800,color:sellerStats.listed>0?rateColor(sellerStats.successRate):'#94a3b8'}}>{sellerStats.listed>0?sellerStats.successRate+'%':'-'}</div>
                <div style={{color:'#64748b'}}>평균 낙찰가</div><div style={{textAlign:'right',fontWeight:700}}>{sellerStats.sold>0?fmtMan(sellerStats.avgWinningPrice)+'만원':'-'}</div>
                <div style={{color:'#64748b'}}>총 수익</div><div style={{textAlign:'right',fontWeight:800,color:'#1B3A5C'}}>{sellerStats.sold>0?fmtMan(sellerStats.totalRevenue)+'만원':'-'}</div>
              </div>
            </div>
            <div style={{padding:'14px',background:'#f8fafc',borderRadius:10,border:'1px solid #e2e8f0'}}>
              <div style={{fontSize:12,fontWeight:700,color:'#1B3A5C',marginBottom:10}}>🎯 입찰자로서</div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,fontSize:12}}>
                <div style={{color:'#64748b'}}>입찰 경매</div><div style={{textAlign:'right',fontWeight:700}}>{fmt(buyerStats.totalBids)}건</div>
                <div style={{color:'#64748b'}}>낙찰</div><div style={{textAlign:'right',fontWeight:700,color:'#10b981'}}>{fmt(buyerStats.wonCount)}건</div>
                <div style={{color:'#64748b'}}>낙찰률</div><div style={{textAlign:'right',fontWeight:800,color:buyerStats.totalBids>0?rateColor(buyerStats.successRate):'#94a3b8'}}>{buyerStats.totalBids>0?buyerStats.successRate+'%':'-'}</div>
                <div style={{color:'#64748b'}}>평균 낙찰가</div><div style={{textAlign:'right',fontWeight:700}}>{buyerStats.wonCount>0?fmtMan(buyerStats.avgWinningBid)+'만원':'-'}</div>
                <div style={{color:'#64748b'}}>총 지출</div><div style={{textAlign:'right',fontWeight:800,color:'#1B3A5C'}}>{buyerStats.wonCount>0?fmtMan(buyerStats.totalSpent)+'만원':'-'}</div>
              </div>
            </div>
          </div>
        )}
      </div>

    </div>
  );
}

export default AuctionStats;
